// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"8647d280","621":"c19602dc","669":"310960ad","672":"71b6cfa1"}[chunkId] + ".chunk.css";
};